import React from "react";
import GoogleMapReact from "google-map-react";
import Indicator from "./Indicator";
import config from "../../config";

const GoogleMap = ({
  centerMap = {},
  zoom = 6,
  indicators = [],
  gkey = "aa",
  highlightAgencyCard = () => {},
}) => {
  const scrollToListItem = id => {
    if (indicators.length) {
      const itemToScrollTo = document.getElementById(`agency-card-${id}`)
        .offsetTop;
      document.querySelector(".agencies-list").scrollTop = itemToScrollTo - 40;
    }
  };

  const handleIndicatorClicked = id => {
    scrollToListItem(id);
    highlightAgencyCard(id);
  };

  return (
    <div style={{ height: "calc(100vh - 70px)", width: "100%" }}>
      <GoogleMapReact
        defaultCenter={centerMap}
        defaultZoom={zoom}
        key={gkey}
        distanceToMouse={() => {}}
        bootstrapURLKeys={{
          key: config.GOOGLE_MAP_API_KEY,
          mapIds: [config.GATSBY_GOOGLE_MAP_ID_1],
          language: "fr",
          region: "ma",
        }}
      >
        {indicators
          .filter(indicator => indicator.latitude)
          .map(indicator => (
            <Indicator
              name={indicator.name}
              id={indicator.id}
              lat={indicator.latitude}
              lng={indicator.longitude}
              key={`${indicator.latitude}+${indicator.longitude}+${indicator.name}`}
              onIndicatorClick={() => handleIndicatorClicked(indicator.id)}
            />
          ))}
      </GoogleMapReact>
    </div>
  );
};

export default GoogleMap;
